var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.terms.length > 0
    ? _c("div", { staticClass: "product-filter-group mb-1" }, [
        _c(
          "button",
          {
            staticClass: "product-filter-group__button collapsed mb-1",
            attrs: {
              "data-toggle": "collapse",
              "aria-expanded": "false",
              role: "button",
              "data-target": "#filter-group--" + _vm.taxonomy,
              "aria-controls": "filter-group--" + _vm.taxonomy,
            },
          },
          [_vm._v(_vm._s(_vm.name))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse",
            class: { long: _vm.terms.length > 10 },
            attrs: { id: "filter-group--" + _vm.taxonomy },
          },
          _vm._l(_vm.terms, function (term) {
            return _c(
              "ProductFilter",
              _vm._b(
                { key: term.id, attrs: { handle: _vm.taxonomy } },
                "ProductFilter",
                term,
                false
              )
            )
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }